import React from "react";

export const HeavySnowIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="42" fill="#3F4447">
                <g transform="translate(4.000000, 10.000000)">
                    <path
                        d="M59.8,41.5 C64.6101126,41.5 68.5,37.6708191 68.5,32.9591837 C68.5,28.2475482 64.6101126,24.4183673 59.8,24.4183673 C59.028541,24.4183673 58.2717181,24.5165958 57.542218,24.7084205 C56.6703769,24.9376744 55.7946983,24.3516066 55.6742128,23.4582156 C55.106043,19.2452796 51.4297438,16.0510204 47.05,16.0510204 C46.9476122,16.0510204 46.8454636,16.0527505 46.7435806,16.0562024 C46.0191859,16.0807451 45.3808628,15.5838045 45.2269834,14.875517 C43.7963581,8.29052937 37.8485919,3.5 30.9,3.5 C23.3707983,3.5 17.0934185,9.1072567 16.328025,16.4017783 C16.2511413,17.1345121 15.6535009,17.7029345 14.9178361,17.7430245 C8.52355909,18.0914806 3.5,23.3011065 3.5,29.6122449 C3.5,36.1723436 8.91211925,41.5 15.6,41.5 L59.8,41.5 Z M59.8,21.4183673 C66.2564963,21.4183673 71.5,26.5800397 71.5,32.9591837 C71.5,39.3383277 66.2564963,44.5 59.8,44.5 L15.6,44.5 C7.26573556,44.5 0.5,37.8398521 0.5,29.6122449 C0.5,22.1099533 6.14080192,15.8675997 13.5172969,14.8649681 C14.9814981,6.64434846 22.2638241,0.5 30.9,0.5 C38.8479898,0.5 45.7195022,5.71939557 47.8640014,13.0786558 C52.8430382,13.4177308 57.0226049,16.8436669 58.3280855,21.508968 C58.8135631,21.4487839 59.3049038,21.4183673 59.8,21.4183673 Z"
                        fillRule="nonzero"
                    />
                    <rect
                        transform="translate(36.363005, 54.000000) rotate(45.000000) translate(-36.363005, -54.000000) "
                        x="34.8630047"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(36.363005, 54.000000) scale(-1, 1) rotate(45.000000) translate(-36.363005, -54.000000) "
                        x="34.8630047"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(15.363005, 54.000000) rotate(45.000000) translate(-15.363005, -54.000000) "
                        x="13.8630047"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(15.363005, 54.000000) scale(-1, 1) rotate(45.000000) translate(-15.363005, -54.000000) "
                        x="13.8630047"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(56.363005, 54.000000) rotate(45.000000) translate(-56.363005, -54.000000) "
                        x="54.8630047"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(56.363005, 54.000000) scale(-1, 1) rotate(45.000000) translate(-56.363005, -54.000000) "
                        x="54.8630047"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                </g>
            </g>
        </g>
    </svg>
);
